var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { DesignTokenSizeEnum, styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
export { DesignTokenSizeEnum as ListGutter };
const StyledList = styled.ul.withConfig({ displayName: "StyledList", componentId: "sc-1v05jo" }) `list-style-type:none;padding:0;margin:0;display:grid;row-gap:${({ theme, gutter }) => theme.size[gutter || 'static300']};`;
export const List = (props) => {
    const { children, gutter, isOrdered = false, appearance } = props, rest = __rest(props, ["children", "gutter", "isOrdered", "appearance"]);
    const commonProps = getCommonProps(props);
    const childrenArr = React.Children.toArray(children);
    const markerSize = Math.floor(Math.pow(childrenArr.length, 1 / 10));
    const childrenElements = childrenArr.map((child) => React.cloneElement(child, {
        appearance,
        markerSize,
    }));
    return (React.createElement(StyledList, Object.assign({ as: isOrdered ? 'ol' : 'ul', gutter: gutter }, commonProps, rest), childrenElements));
};
